export default {
      id: "account_balance_wallet-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#account_balance_wallet",
      toString: function () {
        return this.url;
      }
    }